import { trigger } from '@confluence-classic/confluence-event_DO_NOT_USE';
import { ANALYTICS_SCOPE } from '../../constants/analytics';
import { dangerouslyCreateSafeString } from '@confluence/safe-string';

export const editorPluginAnalytics = (eventName, data) => {
	Object.keys(data).forEach((key) => {
		data[key] = dangerouslyCreateSafeString(data[key]);
	});

	trigger('analytics', {
		name: `${ANALYTICS_SCOPE.EDITOR}.plugins.${eventName}`,
		data,
	});
};
